import React from 'react';

import ResourceForm from './UserForm';
import {confirm} from "../../../components/ui/dialogs";
import {GenericResourceStore} from "../../../store/mobx/GenericResourceStore";
import {observer} from "mobx-react";
import {Icon} from '@mdi/react';
import {mdiTrashCanOutline} from "@mdi/js";

type ResourceUpdateProps = {
    sharedGridResourceCollectionStore: GenericResourceStore,
    canRemove: boolean,
    canEdit: boolean
}
const ResourceUpdate = observer(({sharedGridResourceCollectionStore, canEdit, canRemove}: ResourceUpdateProps) => {

    const handleDelete = (e) => {
        const position = {
            x: e.clientX,
            y: e.clientY,
        };
        confirm(position, 'Confirm delete action',
            'A you sure you want to delete this resource?').then(() => {
            sharedGridResourceCollectionStore.removeResource()
        });
    };

    return (
        <React.Fragment>

            <div className='remove' onClick={handleDelete}>
                <Icon path={mdiTrashCanOutline}/>
                <p> Delete </p>
            </div>

            {sharedGridResourceCollectionStore.currentResource && <ResourceForm
                initialValues={sharedGridResourceCollectionStore.currentResource}
                disabled={!canEdit}
                onSubmit={sharedGridResourceCollectionStore.updateResource}
            />}


        </React.Fragment>
    );
});


export default ResourceUpdate;
